import { createRoleGuard } from './role-guard';

export const isSuperuserOrAdministratorGuard = createRoleGuard(
  user => user.isSuperuser() || user.isAdministrator()
);
